import React from 'react';

interface MetricCardProps {
  label: string;
  value: string;
  trend: string;
  progress: number;
  highlight?: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({ 
  label, 
  value, 
  trend, 
  progress, 
  highlight = false 
}) => {
  return (
    <div className="metric-card">
      <div className="metric-label">{label}</div>
      <div className={`metric-value ${highlight ? 'highlight' : ''}`}>{value}</div>
      <div className="metric-trend">
        <span className="trend-icon">{trend.split(' ')[0]}</span>
        {trend.split(' ').slice(1).join(' ')}
      </div>
      <div className="data-bar">
        <div className="data-bar-fill" style={{ width: `${progress}%` }}></div>
      </div>
    </div>
  );
};

export default MetricCard;
